import { FC, ReactNode } from 'react';
import { Box, Center, theme } from '@chakra-ui/react';
export interface StepContentProps {
  color: string;
  children?: ReactNode;
}
export const StepContent: FC<StepContentProps> = props => <Box height="full" width="full" position="absolute" zIndex={theme.zIndices.docked} data-sentry-element="Box" data-sentry-component="StepContent" data-sentry-source-file="StepContent.tsx">
    <Center height="full" fontSize="sm" fontWeight="semibold" {...props} data-sentry-element="Center" data-sentry-source-file="StepContent.tsx" />
  </Box>;